function blocks() {
    if ( !! $j('.map-block, .siteplan-wrapper, .iframe-block').length )  {
		$j('.map-block>.activate, .siteplan-wrapper>.activate, .iframe-block>.activate').click(function(){
			var el = $j(this);
			el.fadeOut(300);
		});
	}
}
